import Wrap from '../../../../components/wrap'
import numbers from '../../../../assets/imgs/numbers.png'
import { useMediaQuery } from 'react-responsive';

export default function Coverage() {

    const isMobile = useMediaQuery({
        query: '(max-width: 1024px)',
    });

    return (
        <section className="coverage-section">
            <Wrap>
                <div className="coverage-bg">
                    <div className="text-wrapper">
                        <h2 className="section-title">PIXAD IN FIGURES</h2>
                        <p className="section-desc">Pixad has rapidly reached the milestone of 1 billion monthly ad impressions.</p>
                    </div>
                    {isMobile && <img src={numbers} alt='Pixad Numbers'/>}
                    <div className="circles">
                        <div className="circle">
                            <p className="circle-title"><span className="num" data-val="1.2">1.2</span>B+</p>
                            <p className="circle-desc">ad impressions monthly</p>
                        </div>
                        <div className="circle">
                            <p className="circle-title"><span className="num" data-val="4.1">4.1</span>B+</p>
                            <p className="circle-desc">unique visitors monthly</p>
                        </div>
                    </div>
                    <div className="coverage-footer">
                        <h2 className="section-title">Chosen by the Finest Across the Globe</h2>
                        <p className="section-desc">From Beloved Local Brands to Internationally Acclaimed Enterprises: Embraced by All</p>
                    </div>
                </div>
            </Wrap>
        </section>
    )
}